import React from 'react';
import { motion } from 'framer-motion';
export function FinalCTA() {
  return <section id="book" className="relative overflow-hidden bg-[#C8B4A4] text-brand-dark" data-id="element-37" data-mp="3ucdq8aqe3kqz">
      <div className="pointer-events-none absolute inset-0 opacity-[0.07]" style={{
      backgroundImage: 'radial-gradient(#3b2314 1.5px, transparent 1.5px)',
      backgroundSize: '28px 28px'
    }} data-id="element-38" data-mp="c6iqbhenhf1c" />
      <div className="relative grid min-h-[640px] grid-cols-1 items-stretch lg:grid-cols-2" data-id="element-39" data-mp="m3ngdsbm9unf">
        <div className="flex items-center justify-end px-6 py-20 md:px-12 md:py-24 pl-[30px] pr-[30px]" data-id="element-40" data-mp="h52g5swd7ayz">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="w-full max-w-xl" data-id="element-41" data-mp="vtgkk89fj7hn">
            <span className="mb-4 block text-sm font-extrabold uppercase tracking-widest text-brand-dark/80" data-id="element-42" data-mp="2c5pys0lj7m4t">
              LET&apos;S BUILD YOUR MAINTENANCE PLAN.
            </span>
            <h2 className="mb-6 font-heading text-4xl font-extrabold uppercase leading-[1.05] tracking-wide md:text-5xl lg:text-6xl" data-id="element-43" data-mp="2m2b30jpq8t7l">
              FIND OUT WHERE YOUR CAR ACTUALLY STANDS.
            </h2>
            <p className="mb-10 text-lg font-medium leading-relaxed text-brand-dark/90 md:text-xl" data-id="element-44" data-mp="2v4ak1c0qrxaj">
              Schedule a maintenance inspection and we&apos;ll go through your
              vehicle&apos;s history, identify what&apos;s due, and give you a
              clear picture of what&apos;s coming — before anything is approved.
              No commitment, no pressure. Just a clear picture of where your car
              stands and what it needs.
            </p>
            <div className="mb-5 flex flex-col gap-4 sm:flex-row" data-id="element-45" data-mp="3istu9x3cqk59">
              <a href="https://lancerservice.com" target="_blank" rel="noopener noreferrer" className="inline-flex w-full items-center justify-center whitespace-nowrap rounded-md bg-brand-dark px-8 py-4 text-lg font-bold text-white shadow-2xl transition-colors hover:bg-gray-800 sm:w-auto" data-id="element-46" data-mp="3ir0lab59nnu3">
                Book Maintenance Inspection →
              </a>
              <a href="tel:6512240267" className="flex w-full items-center justify-start gap-2 whitespace-nowrap rounded-md border-2 border-brand-dark bg-transparent px-[15px] py-4 text-[16px] font-bold text-brand-dark transition-colors hover:bg-brand-dark/10 sm:w-auto" data-id="element-47" data-mp="22ekyeoa3pc91">
                Call (651) 224-0267
              </a>
            </div>
            <p className="text-base font-medium text-brand-dark/80" data-id="element-48" data-mp="h1i7gws41gwt">
              Book your appointment online at lancerservice.com
            </p>
          </motion.div>
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 1.05
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.9
      }} className="relative order-first min-h-[320px] lg:order-last lg:min-h-full" data-id="element-49" data-mp="d29bdl9ll6y3">
          <img src="https://cdn.magicpatterns.com/uploads/cRSxQUteRxNCqyWUFaoLcQ/6.20.24Used-0316_Profile_RW_013.jpg" alt="ASE-certified Lancer technician inspecting under the hood" className="absolute inset-0 h-full w-full object-cover" data-id="element-50" data-mp="3u8ax48uoqgzl" />
          <div className="pointer-events-none absolute inset-0" style={{
          background: 'linear-gradient(to right, #C8B4A4 0%, rgba(200,180,164,0.45) 20%, rgba(200,180,164,0) 50%)'
        }} data-id="element-51" data-mp="36ernrp9pqkju" />
          <div className="absolute inset-x-0 bottom-0 h-24 bg-gradient-to-b from-transparent to-[#C8B4A4] lg:hidden" data-id="element-52" data-mp="19jdd34fr8ow4" />
        </motion.div>
      </div>
    </section>;
}